@if(qaBotWidgetService.showNotificationLayout()){
  <div class="license-notification">
    <button
      (click)="onClose()"
      style="position: absolute; top: -8px; right: -16px; background: none; border: none; font-size: 25px; top: 3px;
    right: 15px;cursor: pointer; color: #999; z-index: 10;"
      title="Dismiss notification"
      type="button">
      ×
    </button>
    <div *ngIf="license()?.daysLeft >= 0">Uh-oh! Your free trial is ending in <span class="text-red">{{ license()?.daysLeft }} day(s)</span>😟</div>
    <div *ngIf="license()?.daysLeft < 0">Uh-oh! Your free trial ended <span class="text-red">{{ (license()?.daysLeft * -1) % 30}} day(s) ago</span>😟</div>
    To avoid any interruption, please
    <button type="button" style="background: none; border: none; padding: 0; cursor: pointer; color: #1890ff; text-decoration: underline; font: inherit;" (click)="navigateToPlan()">Subscribe Now</button>!
    or talk to our available Sales representative via
    <button type="button" style="background: none; border: none; padding: 0; cursor: pointer; color: #1890ff; text-decoration: underline; font: inherit;" (click)="openLiveChat()">Live Chat</button>.
  </div>
}
